<modal *ngIf="show" [show]="show" size="sm" (onClose)="closeOtpForm()">
  <h3 class="modal-title" i18n="@@account.passwordChange.otp.title">OTP Confirmation</h3>

  <loading *ngIf="otpLoading">
    <ng-container i18n="@@account.passwordChange.otp.loading">Sending SMS code</ng-container>
  </loading>

  <div *ngIf="otpError" class="alert alert-warning">
    {{otpError}}
  </div>

  <div *ngIf="!otpLoading" class="form forget-password">
    <form [formGroup]="otpForm" (ngSubmit)="onSubmitOTP()">
      <p *ngIf="isTOTP()" i18n="@@account.passwordChange.otp.totpTitle">Fill out the TOTP code</p>
      <p *ngIf="isSMS()" i18n="@@account.passwordChange.otp.smsTitle">SMS code has been sent to {{phoneNumber}}, please fill the code below</p>
      <form-field>
        <div class="d-flex align-items-center">
          <input type="text" formControlName="code" class="flex-grow" autocomplete="one-time-code" placeholder="OTP Code" i18n-placeholder="@@account.passwordChange.otp.code.placeholder">
          <img src="assets/images/icons/password.svg" alt="" class="icon">
        </div>
      </form-field>
      <button type="submit" class="btn btn-primary d-block" [disabled]="!otpForm.valid">{{buttonLabel}}</button>
      <div class="text-center pt-2">
        <a *ngIf="isTOTP() && isSmsEnabled()" href="" (click)="useSMS()" i18n="@@account.passwordChange.otp.sendSmsInsteadButton">Send an SMS code instead</a>
        <a *ngIf="isSMS()" href="" (click)="sendSMS()" i18n="@@account.passwordChange.otp.resendSmsButton">Resend SMS code</a>
      </div>
    </form>
  </div>
</modal>
